export default "__VITE_ASSET__DA7xEdn2__"